module.exports = __webpack_public_path__ + "img/platform-3-icon.a29e84d8.svg";